/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { PaginatedResult_SavedView_ } from '../models/PaginatedResult_SavedView_';
import type { SavedView } from '../models/SavedView';
import type { SavedViewCreateBodyParams } from '../models/SavedViewCreateBodyParams';
import type { SavedViewModelType } from '../models/SavedViewModelType';
import type { SavedViewUpdateBodyParams } from '../models/SavedViewUpdateBodyParams';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class CrmSavedViewsService {
    /**
     * @param model
     * @param filterBy
     * @param searchBy
     * @param sortBy
     * @param page
     * @param pageSize
     * @param pageToken
     * @returns PaginatedResult_SavedView_ Ok
     * @throws ApiError
     */
    public static getSavedViews(
        model: SavedViewModelType,
        filterBy?: string,
        searchBy?: string,
        sortBy?: string,
        page?: number,
        pageSize?: number,
        pageToken?: string,
    ): CancelablePromise<PaginatedResult_SavedView_> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/crm/saved-views',
            query: {
                'filterBy': filterBy,
                'searchBy': searchBy,
                'sortBy': sortBy,
                'page': page,
                'pageSize': pageSize,
                'pageToken': pageToken,
                'model': model,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * @param requestBody
     * @returns SavedView Ok
     * @throws ApiError
     */
    public static createSavedView(
        requestBody: SavedViewCreateBodyParams,
    ): CancelablePromise<SavedView> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/crm/saved-views',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * @param id
     * @returns SavedView Ok
     * @throws ApiError
     */
    public static getSavedView(
        id: number,
    ): CancelablePromise<SavedView> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/crm/saved-views/{id}',
            path: {
                'id': id,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Resource not found`,
            },
        });
    }
    /**
     * @param id
     * @param requestBody
     * @returns SavedView Ok
     * @throws ApiError
     */
    public static updateSavedView(
        id: number,
        requestBody: SavedViewUpdateBodyParams,
    ): CancelablePromise<SavedView> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/crm/saved-views/{id}',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Resource not found`,
            },
        });
    }
    /**
     * @param id
     * @returns SavedView Ok
     * @throws ApiError
     */
    public static deleteSavedView(
        id: number,
    ): CancelablePromise<SavedView> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/crm/saved-views/{id}',
            path: {
                'id': id,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Resource not found`,
            },
        });
    }
}
